export default __webpack_public_path__ + "static/iconography-image-k-97b2995d7873405b7c750c9108ceda0d93578f3b6f45e5727db9cf36dbf88c01.png";